import { render, staticRenderFns } from "./DeleteTypeAffiliation.vue?vue&type=template&id=1534b300&"
import script from "./DeleteTypeAffiliation.vue?vue&type=script&lang=js&"
export * from "./DeleteTypeAffiliation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports